import React, { Component } from 'react'
import ScrollToTop from '../../../components/ScrollToTop'
import MenuSider from '../../../components/MenuSider'
import { Icon } from 'antd';
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom'
import { Odata_Url, Constants } from '../../../Constants/Constants'
import IntlMessages from '../../../util/IntlMessages';
import axios from 'axios'
import my_profile from '../images/img_avatar.png'
import './Profile.css'

class Profile extends Component {
    constructor() {
        super();

        this.state = {
            Name_Full_En: "",
            image: my_profile
        }
    }

    componentWillMount() {

        if (localStorage.getItem("ObsReqFromTag")) {
            const observationRequestFromTagNo = localStorage.getItem("ObsReqFromTag");
            localStorage.removeItem("ObsReqFromTag");
            window.location.href = "observation/req-from-tag/" + observationRequestFromTagNo;
        }

        if (localStorage.getItem("ObsReqRedirectAfterLogin")) {
            localStorage.removeItem("ObsReqRedirectAfterLogin");
            window.location.href = "observation/request";
        }

        // var username = window.localStorage.getItem("authen")    
        // username = username.toLowerCase()
        this.props.CLEAR_IMAGE_CATEGORY()
        this.props.CLEAR_BASIC_INFO()
        var state = JSON.parse(window.localStorage.getItem("state"))

        var userid = state.authen.UserID

        // console.log(userid)

        if (userid === undefined || userid === "") {

            // Get Company Template //
            const companyid = window.localStorage.getItem("CompanyID")

            var Token
            return axios.get(Constants.BASE_URL + 'auth/token')
                .then((response) => {
                    Token = response.data
                    // console.log(Token)

                    let $getComTmp = axios.get(
                        Odata_Url + `OCompany_TemplateMD?$filter=IsActived eq true and CompanyID eq ` + companyid,
                        {
                            headers: {
                                "Authorization": "Bearer " + Token,
                            }
                        }
                    )
                        .then((response) => {
                            var TemplateID
                            response.data.value.forEach(function (element) {
                                TemplateID = element.TemplateID
                            });
                            // console.log("Template" + TemplateID)
                            this.props.set_templateid(TemplateID)

                            // Get Sub Template //

                            axios.get(
                                Odata_Url + `OSub_Template?$filter=IsActived eq true and TemplateID eq ` + TemplateID,
                                {
                                    headers: {
                                        "Authorization": "Bearer " + Token,
                                    }
                                }
                            )
                                .then((response) => {
                                    var CategoryID = []
                                    var SubCategoryID = []
                                    var boo = true
                                    response.data.value.forEach(function (element) {
                                        for (let i = 0; i < CategoryID.length; i++) {
                                            if (CategoryID[i] === element.CategoryID) {
                                                boo = false
                                            }
                                        }
                                        if (boo) {
                                            CategoryID.push(element.CategoryID)
                                        } else {
                                            boo = true
                                        }
                                        SubCategoryID.push(element.SubCategoryID)

                                    });
                                    this.props.set_categoryid(CategoryID)
                                    this.props.set_subcategoryid(SubCategoryID)
                                },
                                    (error) => {
                                        console.log(error);
                                    });
                        },
                            (error) => {
                                console.log(error);
                            });

                    const user = window.localStorage.getItem("authen")

                    let $getProfileImg = axios.get(Constants.BASE_URL + 'api/MDMProfileImage/ProfileImage?adAccount=' + user,
                        {
                            headers: {
                                "Authorization": "Bearer " + Token,
                            }
                        })
                        .then((response) => {
                            if (response.data.responseData !== null) {
                                this.setState({ image: "data:image/jpg;base64," + response.data.responseData.imageByte });
                            }
                        },
                            (error) => {
                                console.log(error);
                            })

                    return $getProfileImg;
                },
                (error) => {
                    console.log(error);
                    if (401 === error.response.status) {
                        window.location.href = "auth";
                    }
                    });
        }
    }
    render() {
        const User_info = JSON.parse(window.localStorage.getItem("User_Info"))
        const state = JSON.parse(window.localStorage.getItem("state"))
        if (state.authen.UserID === "" || state.authen.UserID === null) {
            window.localStorage.clear();
            return <Redirect to='/signin' />
        }

        var locale = state.setting.locale.locale
        var full_name_en = User_info.UserFullName_ENG
        var full_name_th = User_info.UserFullName_TH
        var full_name
        if (locale === "th") {
            full_name = full_name_th
        } else {
            full_name = full_name_en
        }

        return (
            <div>
                <ScrollToTop />
                <MenuSider title={<IntlMessages id="menu.profile" />} style={{ textAlign: "center" }}>
                    <div style={{ width: "100%", textAlign: "center" }}>
                        <img
                            className="image-profile"
                            src={this.state.image}
                            style={{ width: "120px", height: "120px", borderRadius: "50%", objectFit: "scale-down", border: "2px solid #e3e9ed" }}
                            alt='Profile'
                        />
                        <div className="name-profile" style={{ fontSize: "16px", fontWeight: "bold", color: "black" }}>
                            {full_name}
                        </div>
                    </div>

                    <div style={{ width: "70px", height: "70px", position: "fixed", right: "25px", bottom: "40px", border: "1px solid rgb(1 135 124)", backgroundColor: "rgb(0,152,139)", borderRadius: "50%" }}>
                        <Link to="/observation/request">
                            <Icon type="plus" style={{ left: "25%", top: "25%", position: "relative", color: "white", fontSize: "35px" }} />
                        </Link>
                    </div>
                </MenuSider>
            </div>
        );
    }
}

const mapStatetoProps = (state) => {
    return {
        detail: state.detail,
        authen: state.authen,
        detailMyOb: state.detailMyOb,
    }
}

const mapDispatchProps = (dispatch) => {
    return {
        set_MonthPicker: (value) => {
            dispatch({
                type: "set_MonthPicker",
                MonthPicker: value
            })
        },
        set_DefalutmonthPicker: () => {
            dispatch({
                type: "set_DefalutmonthPicker",
            })
        },
        Set_InitialValue: () => {
            dispatch({
                type: "Set_InitialValue",
            })
        },
        ClearState2: () => {
            dispatch({
                type: "ClearState2",
            })
        },
        Set_InitialValue_step2: () => {
            dispatch({
                type: "Set_InitialValue_step2",
            })
        },
        set_userid: (value) => {
            dispatch({
                type: "Set_userid",
                UserID: value
            })
        },
        set_companyid: (value) => {
            dispatch({
                type: "Set_companyid",
                CompanyID: value
            })
        },
        set_templateid: (value) => {
            dispatch({
                type: "Set_templateid",
                TemplateID: value
            })
        },
        set_categoryid: (value) => {
            dispatch({
                type: "Set_categoryid",
                CategoryID: value
            })
        },
        set_subcategoryid: (value) => {
            dispatch({
                type: "Set_subcategoryid",
                SubcategoryID: value
            })
        },
        CLEAR_IMAGE_CATEGORY: () => {
            dispatch({
                type: "CLEAR_IMAGE_CATEGORY",
            })
        },
        CLEAR_BASIC_INFO: () => {
            dispatch({
                type: "CLEAR_BASIC_INFO",
            })
        },
        SET_NAME: (value) => {
            dispatch({
                type: "SET_NAME",
                Name: value
            })
        },
    }
}

export default connect(mapStatetoProps, mapDispatchProps)(Profile)